import { Component, Input, Type } from '@angular/core';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { IGetClass, IModalWindow, ISetOptions } from 'src/app/utils/interfaces/modal-dialog.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'asg-yes-no-dialog',
    templateUrl: './yes-no-dialog.component.html',
    styleUrls: ['./yes-no-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class YesNoDialogComponent implements IModalWindow, ISetOptions, IGetClass {
  @Input() no: () => void;
  @Input() ok: () => void;

  yesHandler: () => void;
  noHandler: () => void;
  messageKey: string;

  constructor() {
  }

  getWindowType(): Type<IModalWindow> {
    return YesNoDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.YES_NO_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | ISetOptions | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  setOptions(options: any): void {
    options = options || {};
    this.messageKey = options.messageKey;
    this.yesHandler = options.yesHandler;
    this.noHandler = options.noHandler;
  }

  getClass(): string {
    return 'common-message-dlg';
  }

  yes = () => {
    this.yesHandler();
    this.ok();
  }

  cancel = () => {
    if (this.noHandler) {
      this.noHandler();
    }

    this.no();
  }
}
